import React from 'react'

import { DigitalTransformationCase } from '@components/cases/DigitalTransformationCase'
import { CustomHead } from '@ui/sections/CustomHead'

function DigitalTransformationPage() {
  return (
    <>
      <CustomHead
        title="Digital Platforms for Education Company"
        description="Learn how we helped the client build three platforms with advanced functionality to scale up their business. Find out the project stages and the benefits the client got from platform implementation."
        imagePath="/images/custom-head/custom-head-digital-transformation.webp"
      />
      <DigitalTransformationCase />
    </>
  )
}

export default DigitalTransformationPage
